require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-glenvill-ceo-len-warson-was-invited-by-real-estate.json") })
        }
      }, "path---news-glenvill-ceo-len-warson-was-invited-by-real-estate");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-glenvill-ceo-len-warson-was-invited-by-real-estate!./.cache/json/news-glenvill-ceo-len-warson-was-invited-by-real-estate.json
// module id = 816
// module chunks = 231608221292675